"use client";

import { c as _c } from "react/compiler-runtime";
import type { CartPaymentResponseDto, PaymentMethodType } from "@sticker-giant/sg-frontend-common";
import { usePaymentMutation } from "./usePaymentMutation";
export const finalizePayPalMutationKey = ["finalizePayPal"] as const;
type FinalizePayPalInput = {
  paymentMethod: PaymentMethodType;
  transactionId: string;
};
export function useFinalizePayPalPayment() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationKey: finalizePayPalMutationKey,
      method: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return usePaymentMutation(t0);
}
function _temp(cartClient, cartId, t0) {
  const {
    paymentMethod,
    transactionId
  } = t0;
  return cartClient.postFinalizePayPalPayment(cartId, paymentMethod, transactionId);
}